export var CheggBaseUrlProduction = 'https://www.chegg.com';
export var ProjectName = 'user-address';
export var AppProductionConfigs = {
  cdnUrl: 'https://c.cheggcdn.com/assets/',
  flagUrl: 'https://c.cheggcdn.com/assets/site/flag-icons/'
};
export var AppDevConfigs = {
  cdnUrl: 'https://gce.test.cheggcdn.com/assets/',
  flagUrl: 'https://gce.test.cheggcdn.com/assets/site/flag-icons/'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/constants/AppConstants.js
// module id = 1489
// module chunks = 11